<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div
      id="kt_app_content_container"
      class="app-container container-fluid patient-list-page-container"
    >
      <div>
        <!-- HEADER + BUTTONS -->
        <div class="d-flex justify-content-between align-items-center mb-4">
          <div class="d-flex flex-column">
            <h3 class="card-label fw-bold fs-3 mb-1">
              {{
                patientConfig?.pageTitleKey
                  ? (patientConfig?.pageTitleKey | translate)
                  : ("patientList" | translate)
              }}
            </h3>
          </div>

          <div class="d-flex align-items-center gap-3">
            <!-- Filter btn -->
            <button
              class="btn btn-icon btn-active-light-primary cursor-pointer"
              (mouseenter)="showTooltip($event, 'filter')"
              (mouseleave)="hideTooltip()"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseExample"
              aria-expanded="false"
              aria-controls="collapseExample"
            >
              <i class="fa-solid fa-filter"></i>
            </button>

            <!-- Custom tooltip element -->
            <div
              class="risk-tooltip"
              *ngIf="activeTooltip"
              [style.left.px]="activeTooltip.x"
              [style.top.px]="activeTooltip.y"
            >
              {{ activeTooltip.text }}
            </div>

            <!-- Create new patient btn -->
            <div class="d-flex align-items-center gap-3">
              <a
                [routerLink]="['/patient/create']"
                class="btn btn-sm fw-bold btn-primary"
                *appHasClaim="'create_patient_claim'"
              >
                {{ "createNewPatient" | translate }}
              </a>
            </div>
          </div>
        </div>

        <!-- FILTERS -->
        <ng-container>
          <div>
            <div class="collapse mb-8" id="collapseExample">
              <form (ngSubmit)="getPatientList(1, pageSize, filterForm)">
                <div class="row align-items-end">
                  <!-- Name Surname -->
                  <div class="col-xl-3 col-lg-4 col-sm-6 mt-4">
                    <label class="form-label fs-14">
                      {{ "patientNameSurname" | translate }}
                    </label>
                    <input
                      [(ngModel)]="filterForm.name"
                      name="name"
                      type="text"
                      class="form-control fs-14"
                      [placeholder]="'filterByNameAndSurname' | translate"
                    />
                  </div>

                  <!-- PID -->
                  <div class="col-xl-3 col-lg-4 col-sm-6 mt-4">
                    <label class="form-label fs-14">
                      {{ "pid" | translate }}
                    </label>
                    <input
                      [(ngModel)]="filterForm.pid"
                      name="pid"
                      type="text"
                      class="form-control fs-14"
                      [placeholder]="'filterByPID' | translate"
                    />
                  </div>

                  <!-- Start Date -->
                  <div class="col-xl-3 col-lg-4 col-sm-6 mt-4">
                    <label class="form-label fs-14">
                      {{ "startDate" | translate }}
                    </label>
                    <input
                      [(ngModel)]="filterForm.startDate"
                      name="startDate"
                      type="date"
                      class="form-control fs-14"
                      max="9999-12-31"
                      (input)="validateDateInput($event, 'startDate')"
                    />
                  </div>

                  <!-- End Date -->
                  <div class="col-xl-3 col-lg-4 col-sm-6 mt-4">
                    <label class="form-label fs-14">
                      {{ "endDate" | translate }}
                    </label>
                    <input
                      [(ngModel)]="filterForm.endDate"
                      name="endDate"
                      type="date"
                      class="form-control fs-14"
                      max="9999-12-31"
                      (input)="validateDateInput($event, 'endDate')"
                    />
                  </div>

                  <!-- Organization -->
                  <div
                    *ngIf="isSystemAdmin"
                    class="col-xl-3 col-lg-4 col-sm-6 mt-4"
                  >
                    <label class="form-label fs-14">{{
                      "ORGANIZATION" | translate
                    }}</label>
                    <!-- <select
                    [(ngModel)]="filterForm.organizationId"
                    class="form-control form-select fs-14 cursor-pointer"
                    name="organizationId"
                  >
                    <option value="">
                      {{ "roleList.allOrganizations" | translate }}
                    </option>
                    <option *ngFor="let org of organizations" [value]="org.id">
                      {{ org.name }}
                    </option>
                  </select> -->
                    <app-select
                      [(ngModel)]="filterForm.organizationId"
                      [items]="organizations"
                      bindLabel="name"
                      bindValue="id"
                      [clearable]="true"
                      name="organizationId"
                      appendTo="body"
                      [placeholder]="'ORGANIZATION' | translate"
                    >
                    </app-select>
                  </div>

                  <!-- Buttons -->
                  <div class="col-xl-3 col-lg-4 col-sm-6 mt-4">
                    <div class="d-flex justify-content-start gap-4">
                      <button
                        type="button"
                        class="btn btn-secondary cursor-pointer fs-14 flex-grow-1"
                        (click)="clearFilters()"
                      >
                        {{ "clear" | translate }}
                      </button>
                      <button
                        type="submit"
                        class="btn btn-primary cursor-pointer fs-14 flex-grow-1"
                      >
                        {{ "filter" | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </ng-container>
        <!-- LIST CONTAINER -->
        <div>
          <!-- Loading -->
          <div
            *ngIf="patientListLoading"
            class="d-flex justify-content-center pb-4"
          >
            <div class="spinner-border text-danger" role="status">
              <span class="visually-hidden"
                >{{ "loading" | translate }}...</span
              >
            </div>
          </div>

          <!-- Empty state -->
          <div
            *ngIf="!patientListLoading && patients.length === 0"
            class="py-5 text-center fs-5"
          >
            {{ "noPatients" | translate }}
          </div>

          <!-- GRID HEADER -->
          <div
            class="grid-header"
            *ngIf="
              (patientConfig?.columns?.length || 0) > 0 &&
              !patientListLoading &&
              patients.length > 0
            "
          >
            <ng-container
              *ngFor="
                let col of patientConfig?.columns ||
                  ([] && !patientListLoading && patients.length > 0)
              "
            >
              <div
                [ngClass]="getColClass(col)"
                (click)="
                  col.key === 'fullName'
                    ? onSort('patientName')
                    : col.key === 'patientOrganization' &&
                        col.labelKey === 'createdDate'
                      ? onSort('createdDate')
                      : col.key === 'patientOrganization' &&
                          col.labelKey === 'organizationCode'
                        ? onSort('organizationCode')
                        : null
                "
                [class.cursor-pointer]="
                  col.key === 'fullName' ||
                  (col.key === 'patientOrganization' &&
                    ['createdDate', 'organizationCode'].includes(col.labelKey))
                "
              >
                {{ col.labelKey | translate }}
                <ng-container
                  *ngIf="
                    (filterForm.sortBy === 'patientName' &&
                      col.key === 'fullName') ||
                    (filterForm.sortBy === 'createdDate' &&
                      col.key === 'patientOrganization' &&
                      col.labelKey === 'createdDate') ||
                    (filterForm.sortBy === 'organizationCode' &&
                      col.key === 'patientOrganization' &&
                      col.labelKey === 'organizationCode')
                  "
                >
                  <i
                    class="fa-solid ms-1"
                    style="font-size: 0.65em !important; vertical-align: middle"
                    [ngClass]="{
                      'fa-chevron-down': filterForm.sortDirection === 'desc',
                      'fa-chevron-up': filterForm.sortDirection === 'asc',
                    }"
                  ></i>
                </ng-container>
              </div>
            </ng-container>
          </div>

          <!-- CARD LIST -->
          <ng-container *ngIf="!patientListLoading && patients.length > 0">
            <app-dynamic-list
              *ngFor="let patient of patients"
              [item]="patient"
              [columns]="patientConfig.columns"
              [actions]="patientConfig.actions"
              [disableScrollableItems]="true"
              (click)="onCardClick(patient)"
            >
            </app-dynamic-list>
          </ng-container>
        </div>

        <!-- PAGINATION -->
        <ng-container *ngIf="!patientListLoading && patients.length > 0">
          <div class="d-flex flex-stack flex-wrap pt-10">
            <div class="d-flex align-items-center gap-6">
              <div class="flex align-items-center gap-2">
                <label class="me-2 fs-6 fw-semibold text-gray-700">
                  {{ "pageSize" | translate }}:
                </label>
                <app-page-size-selector
                  [sizes]="pageSizes"
                  [selectedSize]="pageSize"
                  (sizeChange)="changePageSize($event)"
                >
                </app-page-size-selector>
              </div>
              <div class="fs-6 fw-semibold text-gray-700">
                {{ "showing" | translate }} {{ patients.length }}
                {{ "of" | translate }} {{ totalPatient }}
                {{ "patients" | translate }}
              </div>
            </div>

            <ul class="pagination">
              <li
                class="page-item previous cursor-pointer"
                [class.disabled]="currentPage === 1"
              >
                <a class="page-link" (click)="changePage(currentPage - 1)">
                  <i class="previous"></i>
                </a>
              </li>

              <li
                *ngFor="let page of [].constructor(totalPage); let i = index"
                class="page-item cursor-pointer"
                [class.active]="currentPage === i + 1"
              >
                <a class="page-link" (click)="changePage(i + 1)">{{ i + 1 }}</a>
              </li>

              <li
                class="page-item next cursor-pointer"
                [class.disabled]="currentPage === totalPage"
              >
                <a class="page-link" (click)="changePage(currentPage + 1)">
                  <i class="next"></i>
                </a>
              </li>
            </ul>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- Delete Patient Modal -->
<div
  class="modal fade"
  id="deletePatientModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-2" id="exampleModalLabel">
          {{ "deletePatient" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close cursor-pointer"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body fs-4">
        {{
          "thisActionCannotBeUndoneAreYouSureYouWantToDeleteThisPatient"
            | translate
        }}
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary cursor-pointer"
          data-bs-dismiss="modal"
        >
          {{ "cancel" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary cursor-pointer"
          (click)="deletePatient(deleteModalId)"
          data-bs-dismiss="modal"
        >
          {{ "delete" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
